<template>
  <div class='chart-legend'>
    <div @click='onClick(label, $event)' class='legend-item' v-for='(label, i) in chartdata.labels'>
      <div class="legend-key">
        <span class='color' :style='{backgroundColor: chartdata.datasets[0].backgroundColor[i]}'></span>
      </div>
      <p class='legend-label'><b>{{label}}</b> - <span class='legend-stats'>{{ legendLabel(i)}}</span></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    chartdata: {type: Object, default: ()=>{{}}}
  },
  methods: {
    onClick (label, $event) {
      this.$emit('select', {target: this, selected: label})
    },
    legendLabel (i) {
      const label = this.chartdata.labels[i]
      const dataset = this.chartdata.datasets[0]
      // const count = dataset.counts[i]
      // const total = dataset.totals[i]
      // const percent = (dataset.data[i] * 100).toFixed(2);
      return `${label} (${dataset.data[i]})`
    }
  }
}
</script>
<style scoped lang='scss'>
.chart-legend {
  position: relative;
}
  div.legend-item {
    position: relative;
    display:table;
    width: 100%;
    //white-space: nowrap;
    word-break: break-all;
    //transition: 0.3s all;
    cursor: pointer;
    z-index: 1;
  }
  .legend-key {
    display: table-cell;
    width: 35px;
  }
  span.color {
    display: inline-block;
    width: 30px;
    height: 10px;
    border: 1px solid #efefef;
  }
  p.legend-label {
    margin: 0 0 0.3em;
    display: table-cell;
    margin-left: 0.3em;
    font-size: 70%;
    color: #555;
    .legend-stats {
      white-space: nowrap;
    }
  }
</style>